import TAGSORT,{taglist} from "../class/tagsort";

const [d] = [document];

const itemTemplate =  `
  <div class="case-list" :class="[ 'is-paged-' + paged ]">
    <div class="case-list__inner">
      <div v-for="(article , ind) in pagedArticles">
        <a :href="article.href" class="case-item">
          <span class="cat" v-if="article.category.name">{{ article.category.name }}</span>
          <div class="case-item__img-wrap">
            <img :src="article.thumb" :alt="article.title" class="case-item__img" width="355" height="355">
          </div>
          <div class="case-item__body">
            <span class="title">{{ article.title }}</span>
            <span class="tags" v-if="article.keywords.length">
              <span class="tag" v-for="(tag, ind) in article.keywords">#{{ tag }}</span>
            </span>
          </div>
          <!-- /.case-item__body -->
        </a>
        <!-- /.case-item-->
      </div>
    </div>
  </div>
  `;

const relatedItemTemplate =  `
  <div class="case-list is-related" v-if="relatedArticles.length">
    <h3 class="case-list__title">《関連実績》</h3>
    <div class="case-list__inner">
      <div v-for="(article , ind) in relatedArticles">
        <a :href="article.href" class="case-item">
          <span class="cat" v-if="article.category.name">{{ article.category.name }}</span>
          <div class="case-item__img-wrap">
            <img :src="article.thumb" :alt="article.title" class="case-item__img" width="355" height="355">
          </div>
          <div class="case-item__body">
            <span class="title">{{ article.title }}</span>
            <span class="tags" v-if="article.keywords.length">
              <span class="tag" v-for="(tag, ind) in article.keywords">#{{ tag }}</span>
            </span>
          </div>
          <!-- /.case-item__body -->
        </a>
        <!-- /.case-item-->
      </div>
    </div>
  </div>
  `;


class taglist_custom extends taglist {
  constructor( opt, parent ) {
    super( opt, parent );
  }
  insertContainer ( tag = `<taglist />`) {
    const container = d.querySelector( this.opt.container || '.rwd002-container');
    const pagination = d.querySelector( this.opt.pagination || '.rwd002-pagination');
    const is_list = d.body.classList.contains('is--list');
    if( !container ) return false;

    // top
    if( is_list ){
      container.insertAdjacentHTML('beforebegin', tag);
    }

    // bottom
    if( pagination ){
      pagination.insertAdjacentHTML('afterend', tag);
    }else {
      container.insertAdjacentHTML('afterend', tag);
    }

  }
}

const domReady = () => {
  
  const Tagsort = new TAGSORT({
    list: {
      itemTemplate,
      perpage: 18, // 一度に表示する記事数
    },
    taglist: {
      pagination: '.rwd002-pagination', // taglistを表示する基準の要素
    },
    related: {
      container: '.rwd002-pagination',
      itemTemplate: relatedItemTemplate
    }
  });

  d.addEventListener('tagsort.beforeInit', e => {
    const TAGSORT = e.detail;
    Tagsort.taglist = new taglist_custom( TAGSORT.opt.taglist, TAGSORT );
  });

  Tagsort.render();
};

export default function CASE () {
  // テンプレートが用意したDOMContentLoaded（テンプレートインスタンスが引数に入る）
  d.addEventListener('rwd002.beforeDomready', e => domReady(e.detail) );
}